import { render, staticRenderFns } from "./itemReleaseManageList.vue?vue&type=template&id=66f202e3&scoped=true"
import script from "./itemReleaseManageList.vue?vue&type=script&lang=js"
export * from "./itemReleaseManageList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseManageList.vue?vue&type=style&index=0&id=66f202e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f202e3",
  null
  
)

export default component.exports